import { collection, getDocs, query, where } from "firebase/firestore";
import { useEffect, useState } from "react";
import { db } from "../Firebase/firebase";

const useGetChatRoomsAsClient = (userId) => {
  
  const [chatRoomsArr, setChatRoomsArr] = useState([]);
  // chatRoomsArr setChatRoomsArr
  const gettingChatRoomsAsClient = async () => {
    // console.log(userId)
    const tempChatRooms = [];
    try {
      const clientChatsQuery = query(collection(db, "chats"), where("clientId", "==", userId));
      const querySnapshot = await getDocs(clientChatsQuery);
      querySnapshot.forEach((doc) => {
        tempChatRooms.push({ ...doc.data(), chatRoomId: doc.id });
      });
      // console.log("got the chat rooms");
      setChatRoomsArr((prev) => [...prev, ...tempChatRooms]);
    } catch (err) {
      console.log(err);
    }
  };

  const gettingChatRoomsAsSeller = async () => {
    const tempChatRooms = []
    try {
      const sellerChatQuery = query(collection(db, "chats"), where("sellerId", "==", userId))
      const querySnapshot = await getDocs(sellerChatQuery);
      querySnapshot.forEach((doc) => {
        tempChatRooms.push({ ...doc.data(), chatRoomId: doc.id });
      });
      setChatRoomsArr((prev) => [...prev, ...tempChatRooms]);

    } catch(err) {console.log(err)}
  }

  useEffect(() => {
    // if (userId) {
    gettingChatRoomsAsClient();
    gettingChatRoomsAsSeller()
    //   console.log(chatRoomsArr);
    // }
  }, [userId]);
  //   console.log(chatRoomsArr);
  return { chatRoomsArr };
};

export default useGetChatRoomsAsClient;
